import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import InputIcon from "@mui/icons-material/Input";
import OutputIcon from "@mui/icons-material/Output";
import CategoryIcon from "@mui/icons-material/Category";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { api } from "../../redux/api";

const styles = {
  icon: {fill: '#666666', marginRight: '4px', fontSize: "19px"},
  row: {paddingBottom: '6px'},
  label: {width: '110px', fontWeight: 'bold'},
  content: {
    maxHeight: '470px', 
    padding: '0 !important', 
    fontSize: '12px', 
    fontWeight: '400'
  }
}

const typeIcons = {
  inbound: <InputIcon sx={styles.icon}/>,
  outbound: <OutputIcon sx={styles.icon}/>,
  workflow: <CategoryIcon sx={styles.icon}/>,
}

export default function SaveRevert({revertModalOpen, setRevertModalOpen, checkedTemplates, handleRevertSuccess}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  
  const handleDialogClose = () => setRevertModalOpen(false);
  
  const handleDialogConfirm = () => {
    const getProps = (o) => {
      return { account: o.account, workflow_group: o.workflow_group, template: o.template}
    }

    const revertData = {
      inbound_templates: checkedTemplates.filter(o => o.template_type === 'inbound').map(getProps),
      outbound_templates: checkedTemplates.filter(o => o.template_type === 'outbound').map(getProps),
      workflow: checkedTemplates.filter(o => o.template_type === 'workflow').map(getProps),
    }

    dispatch(api.endpoints.revertAllTemplates.initiate(
      {data: revertData},
      {forceRefetch: true}
    )).then((res) => {
      if (res.data?.current_state === "SUCCESS") {
        handleRevertSuccess(checkedTemplates.map(o => {
          return {
            path: o.path, type: o.template_type
          }
        }));
      } else {
        //TODO: handle this failure somehow. will need to figure this out.
        alert('*Dev message* - Backend to revert templates. Check console to debug.');
        console.warn('Revert request failure: ', res);
      }
    });
  }

  const RevertRows = () => {
    return checkedTemplates.map((o, i) => (
      <div className={`padding-8 flex ${i && i%2 ? 'odd-table-row' : ''}`} key={`revert-` + i}>
        <div className="flex justify-center margin-right-24">
          <div className="padding-left-8 flex align-center">
            {typeIcons[o.template_type]}
            {o.template_type.charAt(0).toUpperCase() + o.template_type.slice(1)}
          </div>
        </div>
        <div>
          <div className="flex" style={styles.row}>
            <div style={styles.label}>{t("ACCOUNT")}:</div>
            <div>{o.account}</div>
          </div>
          <div className="flex" style={styles.row}>
            <div style={styles.label}>{t("LBL_WF_GROUP")}</div>
            <div>{o.workflow_group}</div>
          </div>
          <div className="flex">
            <div style={styles.label}>{t("TEMPLATE")}:</div>
            <div>{o.template}</div>
          </div>
        </div>
      </div>
    ));
  };

  return (
    <Dialog
      onClose={handleDialogClose}
      open={revertModalOpen}
      maxWidth="lg"
      className="dialog-top"
    >
      <DialogTitle className="dialog-header">
        <div className="title">{t("BOX_ARE_YOU_SURE_YOU_WANT_TO_RELOAD_")}</div>
        <div className="description">
          {t("BOX_ALL_CHANGES_WILL_BE_LOST_SINCE_LAST_SAVE")}
        </div>
      </DialogTitle>
      <DialogContent sx={styles.content} className="dialog-content" dividers>
        <RevertRows />
      </DialogContent>
      <DialogActions>
        <Button size='small' variant="outlined" color="primary" onClick={handleDialogConfirm}>
          {t("BOX_CONFIRM")}
        </Button>
        <Button size='small' variant="outlined" color="primary" onClick={() => setRevertModalOpen(false)}>
          {t("BTN_CANCEL")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
